import { AxiosInstance } from "../utils/AxiosInstance.js";
import { getTimeElapsed } from "../utils/utils";
import { Notification, NotificationSettings } from "js/components/types";

export const getNotifications = async () => {
  const { data } = await AxiosInstance.get(`/v1/notifications/`);
  return data.results
    .sort((a, b) => {
      return new Date(b.created_at) - new Date(a.created_at);
    })
    .map((notification: Notification) => {
      // Add a new property 'timeSince' to the notification object
      return {
        ...notification,
        timeSince: getTimeElapsed(new Date(notification.created_at)),
      };
    });
};

export const markNotificationAsRead = async (notificationId: string) => {
  const { data } = await AxiosInstance.patch(
    `/v1/notifications/${notificationId}/update`,
  );
  return data;
};

export const deleteNotification = async (notificationId: string) => {
  return await AxiosInstance.delete(
    `/v1/notifications/${notificationId}/delete`,
  );
};

export const retrieveNotificationSettings = async () => {
  const { data } = await AxiosInstance.get(`/v1/notifications/settings`);
  return data;
};

export const updateNotificationSettings = async (
  data: NotificationSettings,
) => {
  return await AxiosInstance.patch(`/v1/notifications/settings/update`, data);
};
